import { useQuery } from "@tanstack/react-query";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import createUserGroupFilter from "@/utilities/createUserGroupFilter";

/**
 * Returns all active users (max 10000).
 */
export function useAllUsers() {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();

  return useQuery({
    queryKey: ["allUsers", activeSessionId, groups, groupFilterCondition],
    queryFn: ({ signal }) => {
      const now_utc = new Date(new Date().toUTCString());
      const filter = createUserGroupFilter(groups, groupFilterCondition, {
        fromDate: now_utc,
        toDate: now_utc,
      });

      return geotabClient.get("User", filter, 10000, signal);
    },
  });
}
